import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const insuredDetailsValidationSchema = () =>
  Yup.object({
    insuredDetails: Yup.object({
      gender: requiredText(),
      dateOfBirth: requiredText(),
      nationalityID: requiredText(),
      occupationClassID: requiredText(),
      profession: requiredText(),
      passportNumber: requiredText()
    })
  });
